var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68819 9.75853L8.46463 2.98209C9.76689 1.67983 11.8764 1.67983 13.1787 2.98209C14.4809 4.28434 14.4809 6.39388 13.1787 7.69613L5.81298 15.0618C5.42228 15.4525 4.89238 15.672 4.33984 15.672C3.78731 15.672 3.25741 15.4525 2.8667 15.0618C2.476 14.6711 2.25651 14.1412 2.25651 13.5887C2.25651 13.0362 2.476 12.5063 2.8667 12.1155L9.05389 5.92837C9.37798 5.60427 9.90831 5.60427 10.2324 5.92837C10.5565 6.25246 10.5565 6.78279 10.2324 7.10688L4.63447 12.7048L5.51836 13.5887L11.1163 7.99076C11.507 7.60006 11.7265 7.07016 11.7265 6.51762C11.7265 5.96509 11.507 5.43518 11.1163 5.04448C10.7256 4.65378 10.1957 4.43429 9.64314 4.43429C9.09061 4.43429 8.56071 4.65378 8.17001 5.04448L1.98282 11.2317C0.680566 12.5339 0.680566 14.6435 1.98282 15.9457C3.28508 17.248 5.39461 17.248 6.69687 15.9457L14.0626 8.58002C15.8539 6.78868 15.8539 3.88954 14.0626 2.0982C12.2712 0.306867 9.37209 0.306866 7.58075 2.0982L0.80431 8.87464L1.68819 9.75853Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.936c959b99425d68c0bb5bba7bf67eb0.svg";
export { ForwardRef as ReactComponent };